var _path, _path2, _circle, _circle2, _rect, _rect2, _path3, _path4, _path5, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAuditinline = function SvgAuditinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D7E0",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M40 8H10a2 2 0 0 0-2 2v51a2 2 0 0 0 2 2h27m3-55 16 16M40 8v14a2 2 0 0 0 2 2h14m0 0v10.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A7B1BE",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m64 64 8 8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 15,
    fill: "#fff",
    stroke: "#A7B1BE",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 8,
    fill: "#FBDADA",
    stroke: "#EB4748",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 7,
    x: 16,
    y: 16,
    fill: "#D6FFFC",
    stroke: "#00877C",
    strokeWidth: 2,
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 10,
    x: 16,
    y: 45,
    stroke: "#A7B1BE",
    strokeWidth: 2,
    rx: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EB4748",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16 31h24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFBF00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16 37h18"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EB4748",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M53 50v3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 56,
    r: 1,
    fill: "#EB4748"
  })));
};
export default SvgAuditinline;